var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000893749 4.31257H22.9996V3.31718C22.9996 1.11319 21.9003 0 19.7112 0H3.28929C1.1006 0 0.000446928 1.11319 0.000446928 3.31764L0.000893749 4.31257ZM0.000893749 14.6933C0.000893749 16.8978 1.10015 18 3.28929 18H19.7112C21.8998 18 23 16.8978 23 14.6933V6.74212H0L0.000893749 14.6933ZM3.49886 12.082V10.1022C3.49886 9.50317 3.90729 9.07488 4.52529 9.07488H7.09112C7.70912 9.07488 8.11754 9.50317 8.11754 10.1022V12.082C8.11754 12.6921 7.70912 13.1094 7.09112 13.1094H4.52484C3.90684 13.1094 3.49886 12.6921 3.49886 12.082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.2b1b8f451f52b06d0cff5ac5a1b43bfe.svg";
export { ForwardRef as ReactComponent };